$(document).ready(function($) {
  /* Click color change image product */
  jQuery('.engoj_select_color a').each(function() {
    jQuery(this).on("click", function() {
      var engoImage = jQuery(this).data('engojvariant-img');
      jQuery(this).parents('.engoj_grid_parent').find('.engoj_find_img img').attr({src: engoImage});
      return false;
    });
  });
});

/* Live search */
var engoAutoComplate = {
  ajaxProductItems: function(input_element, result_wrapper, result_element) {
    var ajaxUrl = '/search',
        result = new Array(),
        keyword = input_element.val();

    jQuery.ajax({
      type: 'GET',
      data: {
        q: "*" + keyword + "*", /*type: "product", */
        view: "json"
      },
      dataType: "json",
      url: ajaxUrl,
      beforeSend: function() {
        result_wrapper.show();
        result_element.html('<p class="col-12"><svg xml:space="preserve" style="enable-background:new 0 0 50 50;margin-top: -1px;" viewBox="0 0 24 30" height="20px" width="21px" y="0px" x="0px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" id="Layer_1" version="1.1"><rect opacity="0.2" fill="#000" height="8" width="3" y="10" x="0"><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#000" height="8" width="3" y="10" x="8">      <animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#000" height="8" width="3" y="10" x="16"><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect></svg>  Loading... </p>');
      },
      complete: function() {},
      success: function(reponse) {
        var htmlbox = '';
        /* result_element.html(''); */
        if (reponse.length > 0) {
          for (var i = 0; i < reponse.length; i++) {
            var item = reponse[i], template, htmlbox;
            var type = item.object_type,
              title = item.title,
              hightlight = title.replace(new RegExp('(' + keyword + ')', 'gi'), '<span class="hightlight">$1</span>');
              price = item.price,
              handle = item.handle,
              image = item.featured_image,
              compare_price = item.compare_at_price ? '<s class="price-old">' + Shopify.formatMoney(item.compare_at_price, window.money_format) + '</s>' : "",
              sold_out = item.available ? "" : "<span class='item-sold-out'> Sold out </span> ",
              price = item.available ? item.price : item.out_stock_nofication;
              if( image ){
                template = '<div class="col-lg-4 col-sm-6 col-md-6"><ul class="prod_sidebar"><li class="product_info">' + '<a href="/products/' + handle + '">' + '<img style="width: 100% "src="' + image + '" class="img-fluid"/>' + '</a>' + '<h4 class="title-product"><a href="/products/' + handle + '">' + hightlight + '</a></h4>' + '<span><p class="price-product mb-0"><span class="price">' + Shopify.formatMoney(price, window.money_format) + '</span>' + compare_price + '</p></span>' + sold_out + '</li></ul></div>';
              }else{
                template = '<div class="col-lg-4 col-sm-6 col-md-6"><ul class="prod_sidebar"><li class="product_info">' + '<h4 class="title-product"><a href="/products/' + handle + '">' + hightlight + '</a></h4></li></ul></div>';
              }

              htmlbox = htmlbox + template;
            console.log(item);
          }
          result_element.html(htmlbox);
          if ($('.js_productSearchResults .js_search_results li').length) {
            $('.js_productSearchResults').show();
          }
        } else {
          result_element.html('<p class="col-12"> No result found for your search. </p>');
          $('.js_productSearchResults').show();
        }
      }
    });
  },

  ajaxSearch: function(options) {
    var ajax_timeout,
        ajax_lost_focus,
        self = this,
        search_input_id = options.search_input.length > 0 ? options.search_input : '.js_engo_autocomplate',
        wrapper_id = options.result_wrapper.length > 0 ? options.result_wrapper : '.js_productSearchResults',
        result_id = options.result_element.length > 0 ? options.result_element : '.js_search_results';

    jQuery(document).delegate(search_input_id, 'keyup', function(event) {
      var keyword = jQuery(this).val(),
          search_element = jQuery(this),
          result_wrapper = jQuery(wrapper_id),
          result_element = result_wrapper.children(result_id);

      if (ajax_timeout) {
        clearTimeout(ajax_timeout);
      }

      ajax_timeout = setTimeout(function() {
        if (keyword.length >= 1) {
          self.ajaxProductItems(search_element, result_wrapper, result_element);
          self.ajaxPageItems(search_element, result_wrapper, result_element);
        } else {
          result_element.html('<p class="col-12"> You must enter at least 2 characters. </p>');
        }
      }, 300);
    });
  },

  init: function(options) {
    this.ajaxSearch(options);
  }
}

$(document).ready(function() {
  engoAutoComplate.init({"search_input": ".js_engo_autocomplate", "result_wrapper": ".js_productSearchResults", "result_element": ".js_search_results"});
});

/* slider show and ather change */
$(document).ready(function() {
  "use strict";
  function sizeGuide() {
    $('.btn_size_guide').on('click', function() {
      $('.content_size_guide').addClass('active');
      $('.layout_size_guide').addClass('active');
      $('.js_sticky').removeClass('sticky_content');
      $('.overlay').addClass('active');
      $('.question-form-page').hide();
      $('.delivery_return').hide();
    });
    $('.overlay').on('click', function() {
      $('.content_size_guide').removeClass('active');
      $('.layout_size_guide').removeClass('active');
      $('.overlay').removeClass('active');
      $('.question-form-page').show();
      $('.delivery_return').show();
    });
    $('.close_size_guide').on('click', function() {
      $('.js_sticky').addClass('sticky_content');
      $('.content_size_guide').removeClass('active');
      $('.layout_size_guide').removeClass('active');
      $('.overlay').removeClass('active');
      $('.question-form-page').show();
      $('.delivery_return').show();
    });
  }
  
  function deliveryReturn() {
    $('.btn_delivery').on('click', function() {
      $('.content_size_guide').addClass('active');
      $('.js_sticky').removeClass('sticky_content');
      $('.overlay').addClass('active');
      $('.size_guide').hide();
      $('.question-form-page').hide();
    });
    $('.overlay').on('click', function() {
      $('.content_size_guide').removeClass('active');
      $('.overlay').removeClass('active');
      $('.size_guide').show();
      $('.question-form-page').show();
    });
    $('.close_size_guide').on('click', function() {
      $('.js_sticky').addClass('sticky_content');
      $('.content_size_guide').removeClass('active');
      $('.overlay').removeClass('active');
      $('.size_guide').show();
      $('.question-form-page').show();
    });
  }
  
  function askQuestion() {
    $('.btn_question').on('click', function() {
      $('.content_size_guide').addClass('active');
      $('.layout_size_guide').addClass('layout_question');
      $('.js_sticky').removeClass('sticky_content');
      $('.overlay').addClass('active');
      $('.size_guide').hide();
      $('.delivery_return').hide();
    });
    $('.overlay').on('click', function() {
      $('.content_size_guide').removeClass('active');
      $('.overlay').removeClass('active');
      $('.layout_size_guide').removeClass('layout_question');
      $('.size_guide').show();
      $('.delivery_return').show();
    });
    $('.close_size_guide').on('click', function() {
      $('.js_sticky').addClass('sticky_content');
      $('.content_size_guide').removeClass('active');
      $('.overlay').removeClass('active');
      $('.layout_size_guide').removeClass('layout_question');
      $('.size_guide').show();
      $('.delivery_return').show();
    });
  }
  
  function sortLayout() {
    if ($(window).width() < 1300) {
      $('.size_3').addClass('active');
      $('.size_4').removeClass('active');
      $('.size_5').addClass('d-none');
    }
  
    if ($(window).width() >= 1300) {
      $('.size_3').removeClass('active');
      $('.size_4').addClass('active');
      $('.size_5').removeClass('d-none');
    }
  
    if ($(window).width() < 768) {
      $('.size_2').addClass('active');
      $('.size_4').removeClass('active');
      $('.size_5').addClass('d-none');
      $('.size_4').addClass('d-none');
      $('.size_3').addClass('d-none');
    }
    $(window).resize(function() {
      if ($(window).width() < 1300) {
        $('.size_3').addClass('active');
        $('.size_4').removeClass('active');
        $('.size_5').addClass('d-none');
      }
  
      if ($(window).width() >= 1300) {
        $('.size_3').removeClass('active');
        $('.size_4').addClass('active');
        $('.size_5').removeClass('d-none');
      }
  
      if ($(window).width() < 768) {
        $('.size_2').addClass('active');
        $('.size_4').removeClass('active');
        $('.size_5').addClass('d-none');
        $('.size_4').addClass('d-none');
        $('.size_3').addClass('d-none');
      }
    });
  
    $('.size_5').on('click', function() {
      $('.js_size_prod').removeClass('col-lg-1 col-lg-2 col-lg-3 col-lg-4 col-lg-5 col-lg-6 col-lg-7 col-lg-8 col-lg-9 col-lg-10 col-lg-11 col-lg-12 col-lg-2dot4 col-md-1 col-md-2 col-md-3 col-md-4 col-md-5 col-md-6 col-md-7 col-md-8 col-md-9 col-md-10 col-md-11 col-md-12');
      $('.js_size_prod').addClass('col-lg-2dot4');
      $(this).addClass('active');
      $('.size_6').removeClass('active');
      $('.size_4').removeClass('active');
      $('.size_3').removeClass('active');
    });
    $('.size_4').on('click', function() {
      $('.js_size_prod').removeClass('col-lg-1 col-lg-2 col-lg-3 col-lg-4 col-lg-5 col-lg-6 col-lg-7 col-lg-8 col-lg-9 col-lg-10 col-lg-11 col-lg-12 col-lg-2dot4 col-md-1 col-md-2 col-md-3 col-md-4 col-md-5 col-md-6 col-md-7 col-md-8 col-md-9 col-md-10 col-md-11 col-md-12');
      $('.js_size_prod').addClass('col-md-3');
      $(this).addClass('active');
      $('.size_5').removeClass('active');
      $('.size_6').removeClass('active');
      $('.size_3').removeClass('active');
      $('.size_2').removeClass('active');
    });
    $('.size_3').on('click', function() {
      $('.js_size_prod').removeClass('col-lg-1 col-lg-2 col-lg-3 col-lg-4 col-lg-5 col-lg-6 col-lg-7 col-lg-8 col-lg-9 col-lg-10 col-lg-11 col-lg-12 col-lg-2dot4 col-md-1 col-md-2 col-md-3 col-md-4 col-md-5 col-md-6 col-md-7 col-md-8 col-md-9 col-md-10 col-md-11 col-md-12');
      $('.js_size_prod').addClass('col-md-4');
      $(this).addClass('active');
      $('.size_5').removeClass('active');
      $('.size_4').removeClass('active');
      $('.size_6').removeClass('active');
      $('.size_2').removeClass('active');
    });
    $('.size_2').on('click', function() {
      $('.js_size_prod').removeClass('col-lg-1 col-lg-2 col-lg-3 col-lg-4 col-lg-5 col-lg-6 col-lg-7 col-lg-8 col-lg-9 col-lg-10 col-lg-11 col-lg-12 col-lg-2dot4 col-md-1 col-md-2 col-md-3 col-md-4 col-md-5 col-md-6 col-md-7 col-md-8 col-md-9 col-md-10 col-md-11 col-md-12 col-12');
      $('.js_size_prod').addClass('col-6');
      $(this).addClass('active');
      $('.size_3').removeClass('active');
      $('.size_4').removeClass('active');
      $('.size_1').removeClass('active');
    });
  }
  
  function changeProdListGrid() {
    $('.prod_grid').on('click', function() {
      $('.product-grid-view').addClass('active');
      $('.product-list-view').removeClass('active');
      $(this).addClass('active');
      $('.prod_list').removeClass('active');
      $('.prod_per').removeClass('active');
  
    });
    $('.prod_list').on('click', function() {
      $('.product-grid-view').removeClass('active');
      $('.product-list-view').addClass('active');
      $(this).addClass('active');
      $('.prod_grid').removeClass('active');
      $('.prod_per').addClass('active');
    });
  }
  
  function FilterPushLeft() {
    $('.js_filter').on('click', function() {
      $('.filter-to-left').toggleClass('active');
      $('.bg-minicart').addClass('active');
    });  
    $('.close_filter').on('click', function() {
      $('.filter-to-left').removeClass('active');
      $('.bg-minicart').removeClass('active');
    });
    $('.bg-minicart').on('click', function() {
      $('.filter-to-left').removeClass('active');
      $('.bg-minicart').removeClass('active');
    });
  }
  
  function heighthdSticky() {
    $('.detail-info').css({
      'top': function() {
        return $('.js_height_hd').outerHeight() + 10;
      }
    })
    $('.js-slide-item').css({
      'padding-top': function() {
        return $('.js_height_hd').outerHeight();
      }
    })
  }
   
  function jschangethumbnail() {
    $('.js_change_thumbnail').on('click', function() {
      $('.js_change_thumbnail')
        .parent()
        .find('.js_change_thumbnail')
        .removeClass('active')
        $(this)
        .addClass('active');
    });
  }
  
  function js_draw_filter() {
    $('.js-draw-filter-btn').on('click', function() {
      $(this).addClass('js-draw-filter-open');
      $(this).removeClass('js-draw-filter-btn');
      $('.js-draw-filter').removeClass('draw_filter').addClass('col-lg-3');
      $('.js-draw-filter-2').removeClass('col-lg-12').addClass('col-lg-9');
      $('.js-draw-filter-open').on('click', function() {
        $(this).addClass('js-draw-filter-btn');
        $(this).removeClass('js-draw-filter-open');
        $('.js-draw-filter').addClass('draw_filter').removeClass('col-lg-3');
        $('.js-draw-filter-2').addClass('col-lg-12').removeClass('col-lg-9');
      }) 
      setTimeout(function() {
        js_draw_filter()
      })
    })
  }
  
  function jstoolbarScroll() {
    $(window).scroll(function() {
      if ($(this).scrollTop() > 130) {
        $('.js-toolbar-icon').addClass("active");
      } else {
        $('.js-toolbar-icon').removeClass("active");
      };
    });
  }
  
  function checkclickcol() {
    $('.js-check-click-col').on('click', function() {
      $(this).toggleClass('active');
    })
  }

  function js_menu_horiontal() {
    $('.bg-mobile-menu').on('click', function() {
      $('body')
        .removeClass('active')
        $(this)
        .removeClass('active')
        $('.tab-menu-mobile ul')
        .removeClass('active, .active2')
        $('.tab-menu-1')
        .addClass('active')
    })
    $('.js-link-click').each(function() {
      $(this).on('click', function(e) {
        e.preventDefault()
        var id = $(this).attr('data-click')
        $(this).parents('.active').addClass('active2')
        var link = $('[data-open="' + id + '"]')
        link.addClass('active')
      })
    })
    $('.js-header-mobile-menu').each(function() {
      $(this).on('click', function() {
        var $link = $('.tab-menu-mobile')
          .find('.active2')
          .eq(-1)
          $(this)
          .parent()
          .removeClass('active')
        $link
        .removeClass('active2')
      })
    })
  }

  js_menu_horiontal();
  checkclickcol();
  jstoolbarScroll();
  js_draw_filter();
  jschangethumbnail();
  heighthdSticky();
  FilterPushLeft();
  changeProdListGrid();
  sortLayout();
  askQuestion();
  deliveryReturn();
  sizeGuide();
});

$(document).ready(function() {$('[data-toggle="tooltip"]').tooltip();});

/* ather change */
$(document).ready(function() {
  "use strict";
  function promo() {
    $('.close_promo_topbar').on('click', function() {
      $('.promo_topbar').addClass("active");
    });
  }
  function search() {
    $('.js-search-destop').on('click', function() {
      $('.js-box-search').addClass('active');
      $('.bg_search_box').addClass('active');
      $('body').addClass('activedestop');
    });
    $('.js-drawer-close').on('click', function() {
      $('.js-box-search').removeClass('active');
      $('.bg_search_box').removeClass('active');
      $('body').removeClass('activedestop');
    });
    $('.bg_search_box').on('click', function() {
      $('.js-box-search').removeClass('active');
      $('.bg_search_box').removeClass('active');
      $('body').removeClass('activedestop');
    });
  }
  function minicart() {
    $('.js-call-minicart').on('click', function() {
      $('.js-minicart').addClass('active');
      $('.bg-minicart').addClass('active');
    });
    $('.close-mini-cart').on('click', function() {
      $('.js-minicart').removeClass('active');
      $('.bg-minicart').removeClass('active');
    });
    $('.bg-minicart').on('click', function() {
      $('.js-minicart').removeClass('active');
      $('.bg-minicart').removeClass('active');
    });
  }
  function miniaccount() {
    $('.js-call-account').on('click', function() {
      $(this).toggleClass('active');
      $('.box_contentmenu').toggleClass('active');
      $('.box_contentmenu_background').toggleClass('active');
      $('body').addClass('activemenu_mobile');
      $(".tab_navar").removeClass('active');
      $(".tab_navar_right").addClass('active');
      $(".tab-pane:nth-child(1)").removeClass('show active');
      $(".tab-pane:nth-child(2)").addClass('show active');
      $('.form_register').hide();
    });
  }
  function clickshow() {
    $('.item-toggle-tab').on('click', function() {
      $(this).toggleClass('active');
    });
  }
  function menuhorizon() {
    $('.js-model_menu').on('click', function() {
      $('.js-horizon-menu').addClass('active');
      $('.js-bg-horizon-menu').addClass('active');
      $('body').addClass('cartover');
    });
    $('.js_close-menu-horizon').on('click', function() {
      $('.js-horizon-menu').removeClass('active');
      $('.js-bg-horizon-menu').removeClass('active');
      $('body').removeClass('cartover');
    });
    $('.js-bg-horizon-menu').on('click', function() {
      $('.js-horizon-menu').removeClass('active');
      $('.js-bg-horizon-menu').removeClass('active');
      $('body').removeClass('cartover');
    });
  }
  function jsmenuiconh() {
    $('.js_icon_horizon-menu').on('click', function() {
      $(this).parents().addClass('active');
    });
    $('.js-back').on('click', function() {
      $(this)
        .parents()
        .parents()
        .find('.menu-horizon-list')
        .removeClass('active');
    });
  }
  function jscalllogindestop() {
    $('.js-call-popup-login').on('click', function() {
      $('.js-poup-login-destop').addClass('active');
      $('.js-bg-login-popup').addClass('active');
    });
    $('.js-eveland-close-login').on('click', function() {
      $('.js-poup-login-destop').removeClass('active');
      $('.js-bg-login-popup').removeClass('active');
    });
    $('.js-bg-login-popup').on('click', function() {
      $('.js-poup-login-destop').removeClass('active');
      $('.js-bg-login-popup').removeClass('active');
    });
  }
  function jsBackLogin() {
    $('.jsCreate_account').on('click', function() { 
      $('.form_register').show();
      $('.formlogin').hide();
    });
    $('.tab_navar_right').on('click', function() {
      $('.formlogin').show();
      $('.form_register').hide();
    });
    $('.jsBack_login').on('click', function() {
      $('.formlogin').show();
      $('.form_register').hide();
    });
    $('.jsacount_destop').on('click', function() {
      $('.formlogin').show();
      $('.form_register').hide();
    });
  }
  function jslogindestop() {
    $('.jsCreate_account').on('click', function() {
      $('.form_register-destop').show();
      $('.formlogin-destop').hide();
    });
    $('.js-call-popup-login').on('click', function() {
      $('.formlogin-destop').show();
      $('.form_register-destop').hide();
    });
    $('.jsBack_login').on('click', function() {
      $('.formlogin-destop').show();
      $('.form_register-destop').hide();
    });
    $('.jsacount_destop').on('click', function() {
      $('.formlogin-destop').show();
      $('.form_register-destop').hide();
    });
  }
  function mobilescroll() {
    var $nav = $(".jsmenumobile");
    $nav.removeClass('menu_mobilescroll');
    $(document).scroll(function() {
      $nav.toggleClass('menu_mobilescroll', $(this).scrollTop() > $nav.height());
    });
  }
  function menumobile() {
    $('.menuleft').on('click', function() {
      $(this).toggleClass('active');
      $('.box_contentmenu').toggleClass('active');
      $('.box_contentmenu_background').toggleClass('active');
      $('body').addClass('activemenu_mobile')
    });
    $('.box_contentmenu_background').on('click', function() {
      $(this).removeClass('active');
      $('.box_contentmenu').removeClass('active');
      $('.menuleft').removeClass('active');
      $('.box_contentmenu_background').removeClass('active');
      $('body').removeClass('activemenu_mobile');
    });
    $('.js-eveland-close').on('click', function() {
      $(this).removeClass('active');
      $('.box_contentmenu').removeClass('active');
      $('.menuleft').removeClass('active');
      $('.box_contentmenu_background').removeClass('active');
      $('body').removeClass('activemenu_mobile');
    });
  }
  function menutoolbar() {
    $('.btn_bar').on('click', function() {
      $(this).toggleClass('active');
      $('.box_contentmenu').toggleClass('active');
      $('.box_contentmenu_background').toggleClass('active');
    });
    $('.box_contentmenu_background').on('click', function() {
      $(this).removeClass('active');
      $('.box_contentmenu').removeClass('active');
      $('.menuleft').removeClass('active');
      $('.box_contentmenu_background').removeClass('active');
    });
    $('.js-eveland-close').on('click', function() {
      $(this).removeClass('active');
      $('.box_contentmenu').removeClass('active');
      $('.menuleft').removeClass('active');
      $('.box_contentmenu_background').removeClass('active');
    });
  }
  function jsmenu_fullwidth() {
    var top = $('.js_height_hd').offset();
    var height = $('.js_height_hd').outerHeight();
    $('.js-full-width').css({
      'top': top.top + height - 25,
      'position': 'fixed',
      'left': ' 0',
      'right': '0',
      'width': '100%'
    })

    $(window).scroll(function() {
      var height = $('.js_height_hd').outerHeight();
      if ($(window).scrollTop() >= height) {
        $('.js-full-width').css({
          'top': height - 25
        })
      } else {
        $('.js-full-width').css({
          'top': top.top + height - 25
        })
      }
    });
  }
  jsmenu_fullwidth();
  menutoolbar();
  menumobile();
  mobilescroll();
  jslogindestop();
  jsBackLogin();
  jscalllogindestop(); 
  jsmenuiconh();
  menuhorizon();
  clickshow();
  miniaccount();
  minicart();
  search();
  promo();
});

$(document).on("change", ".engoj-agree", function() {
  var input_is_checked = $(".engoj-agree"), btn_dynamic_checkout = $(".more_info").find(".js-button-checkout");
  input_is_checked.is(":checked") ? btn_dynamic_checkout.removeClass("btn-disabled") : btn_dynamic_checkout.addClass("btn-disabled");
});